// Convierte el nombre de ícono que devuelve la API (ej: "TruckIcon")
// al nombre que usa @ng-icons/heroicons/outline (ej: "heroTruck").
// Cualquier ícono nuevo que el backend envíe funciona automáticamente.
export function toNgIconName(apiName: string): string {
  if (!apiName || apiName === 'Dashboard') return 'heroHome';
  return 'hero' + apiName.replace(/Icon$/, '');
}
